import React, { useCallback, useEffect, useState } from 'react';
import { debounce } from '@mui/material';

import Search from 'src/components/search/Search';
import { useLeadsPageContext } from 'src/pages/landlord/leads/provider';

export default function LeadsSearch() {
    const [value, setValue] = useState('');
    const [isSearching, setSearching] = useState(false);

    const { search, setSearch } = useLeadsPageContext();

    const setSearchQueryDebounced = useCallback(debounce(setSearch, 300), []);

    useEffect(() => {
        setSearchQueryDebounced(value);
    }, [value, setSearchQueryDebounced]);

    useEffect(() => {
        if (value !== search) {
            setSearching(true);
        } else {
            setSearching(false);
        }
    }, [value, search]);

    return (
        <Search
            type="search"
            placeholder="Search leads..."
            helperText="Search by name, email, phone, property, stage, notes."
            value={value}
            onChange={setValue}
            size="small"
            fullWidth
            isLoading={isSearching}
            data-testid="leads-search-field"
        />
    );
}
